
import { Fab } from "@material-ui/core";
import { ClassNameMap } from "@material-ui/core/styles/withStyles";
import CleanupIcon from "@material-ui/icons/ClearAll";
import { useState } from "react";
import FormsCleanupDialog from "./FormsCleanupDialog";

interface Props {
  buttonClasses: ClassNameMap;
  customerId: number;
  reportAlerts: (messages: string[]) => void;
  refreshForms: () => void,
}

const FormsCleanupButton = (props: Props) => {
  const [dialogOpen, setDialogOpen] = useState<boolean>(false);

  const handleCleanupButtonClicked = () => {
    setDialogOpen(true);
  };

  const handleCleanupConfirmed = (messages: string[]) => {
    props.reportAlerts(messages);
    setDialogOpen(false);
    props.refreshForms();
  };

  return <>
    <Fab
      aria-label="cleanup"
      className={ props.buttonClasses.button }
      color="primary"
      size="medium"
      onClick={ handleCleanupButtonClicked }
    >
      <CleanupIcon style={ { backgroundColor: 'red', borderRadius: 50, height: 50, width: 50 } } />
    </Fab>
    <FormsCleanupDialog
      customerId={ props.customerId }
      open={ dialogOpen }
      onCleanupConfirmed={ handleCleanupConfirmed }
      onCleanupCanceled={ () => setDialogOpen(false) }
    />
  </>;
}

export default FormsCleanupButton;